module.exports = __webpack_public_path__ + "fonts/Lato-Regular.bb14dc8.ttf";